<template>
  <div class="header-section">
    <div class="header-top">
      <!--      container-fluid-->
      <div class="max-w-full px-4">
        <div class="header-top-content">
          <div class="flex">
            <div class="header-top-logo">
              <TagLink
                :tag="commonLink.home.tag"
                :attr-tag="commonLink.home.attrTag"
              >
                <img
                  src="/image/logo-login.png"
                  :alt="$t('alt.logo_home_banner')"
                  width="138"
                  height="48"
                >
              </TagLink>
            </div>
            <div class="header-top-menu">
              <div class="header-top-menu-item">
                <TagLink
                  class="header-top-menu-item__link"
                  :tag="commonLink.home.tag"
                  :attr-tag="commonLink.home.attrTag"
                >
                  {{ $t("menu.header_top.home") }}
                </TagLink>
              </div>
              <div
                v-for="(link, i) in linkTopDesktop"
                :key="i"
                class="header-top-menu-item"
              >
                <TagLink
                  class="header-top-menu-item__link"
                  :tag="link.tag"
                  :attr-tag="link.attrTag"
                >
                  {{ link.text }}
                </TagLink>
              </div>
            </div>
          </div>
          <div class="header-top-actions">
            <div class="space-s-3 flex items-center">
              <!--  TODO check better way for load component tag link and button -->
              <AppButton
                v-if="!auth.loggedIn"
                :tag="commonLink.login.tag"
                :text="commonLink.login.text"
                v-bind="commonLink.login.attrTag"
                mode="fill"
              >
                <template #icon-right>
                  <AppIcon
                    name="account"
                    size="medium"
                  />
                </template>
              </AppButton>
              <template v-if="auth.loggedIn && auth.user.role === 'admin'">
                <AppButton
                  :tag="commonLink.adminPanel.tag"
                  v-bind="commonLink.adminPanel.attrTag"
                >
                  <span class="text-white">
                    {{
                      Boolean(auth.user.user_fullname)
                        ? auth.user.user_fullname
                        : auth.user.user_mobile_local
                    }}
                    {{ commonLink.adminPanel.text }}
                  </span>
                </AppButton>
                <AppButton
                  :tag="commonLink.logout.tag"
                  v-bind="commonLink.logout.attrTag"
                  mode="outline"
                  :title="commonLink.logout.text"
                  class="
                      flex
                      items-center
                      text-gray-medium
                      hover:text-blue-primary
                      transition-colors
                    "
                >
                  <AppIcon
                    name="exit"
                    size="small"
                    color="text-red-500"
                  />
                </AppButton>
              </template>
              <DropdownButton
                v-if="auth.loggedIn && auth.user.role !== 'admin'"
                :button="{
                  text: Boolean(auth.user.user_fullname)
                    ? auth.user.user_fullname
                    : auth.user.user_mobile_local,
                  mode: 'outline',
                  size: 'sm',
                  color: 'gray',
                }"
                :icon="{
                  name: 'account',
                  color: 'text-gray-medium',
                  size: 'small',
                }"
              />
              <HeaderCtaTeacher
                v-if="auth.loggedIn && auth.user.role === 'teacher'"
              />
              <AppButton
                v-if="!auth.loggedIn"
                :tag="commonLink.startTeaching.tag"
                v-bind="commonLink.startTeaching.attrTag"
                :text="commonLink.startTeaching.text"
                mode="outline"
              >
                <template #icon-right>
                  <AppIcon
                    name="human-male-board"
                    size="medium"
                  />
                </template>
              </AppButton>
              <AppButton
                v-if="auth.loggedIn && ['user'].includes(auth.user.role)"
                :tag="commonLink.startTeaching.tag"
                v-bind="commonLink.startTeaching.attrTag"
                :text="commonLink.startTeaching.text"
                mode="outline"
              >
                <template #icon-right>
                  <AppIcon
                    name="human-male-board"
                    size="medium"
                  />
                </template>
              </AppButton>
            </div>
          </div>
          <div class="header-top-call-center">
            <div class="header-top-call-center__label">
              <span> {{ $t("menu.backup") }}: </span>
              <a
                v-if="ostadbankSupportPhone"
                class="CallButton"
                :href="'tel:' + ostadbankSupportPhone"
              >{{ ostadbankSupportPhone }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DropdownButton from '@library/element/dropdown/dropdown-button'
import HeaderCtaTeacher from '@library/ui/header/header-cta-teacher.vue'
import search from '@mixins/search'

export default {
  name: 'HeaderTopDesktop',
  components: {
    HeaderCtaTeacher,
    DropdownButton
  },
  mixins: [search],
  inject: ['allProps'],
  data () {
    return {
      isSpin: false
    }
  },
  computed: {
    linkTopDesktop () {
      return this.allProps.data.linksHeaderTop.linkTopDesktop
    },
    commonLink () {
      return {
        home: this.allProps.data.linksHeaderTop.home,
        login: this.allProps.data.linksHeaderTop.login,
        logout: this.allProps.data.linksHeaderTop.logout,
        adminPanel: this.allProps.data.linksHeaderTop.adminPanel,
        startTeaching: this.allProps.data.linksHeaderTop.startTeaching
      }
    },
    ostadbankSupportPhone () {
      return this.allProps.data.ostadbankSupportPhone
    },
    auth () {
      return this.allProps.data.auth
    }
  }
}
</script>

<style lang="scss">
.header-top {
  @apply max-h-16;
  &-content {
    @apply py-4 flex justify-between;
  }

  &-logo {
    width: 103px;
    height: 36px;
    @apply inline-block ml-8;
  }

  &-actions {
    @apply flex items-center space-s-4 xl:space-s-12 mr-auto ml-12;
  }

  &-menu {
    @apply flex items-center;
    &-item {
      @apply ml-6 xl:ml-8;
      &__link {
        @apply text-gray-main hover:text-blue-primary transition-colors font-medium cursor-pointer text-xs 2xl:text-base;
      }
    }
  }

  &-call-center {
    @apply flex flex-col relative justify-center;
    &__label {
      @apply flex items-center;
      span {
        @apply text__sub--1 text-gray-medium inline-block ml-1;
      }

      svg {
        @apply text-blue-primary text__sub--2 lg:text-lg;
      }
    }
  }
}
</style>
